// extracted by mini-css-extract-plugin
export var documentation = "_kl-1";
export var menu = "_kl-0";